const numberOrNull = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const amountRules = (rules) => {
  const minimumAmount = numberOrNull(rules?.minimumAmount);
  const maximumAmount = numberOrNull(rules?.maximumAmount);
  const maximumScale = numberOrNull(rules?.maximumScale);
  if (minimumAmount === null || maximumAmount === null || maximumScale === null) {
    return null;
  }
  return { minimumAmount, maximumAmount, maximumScale };
};

export const getFundingAmountRules = (business) => (
  amountRules(business?.paymentRules?.funding)
);

export const getAutoReloadRules = (business) => {
  const range = amountRules(business?.paymentRules?.autoReload);
  const defaultAmount = numberOrNull(business?.paymentRules?.autoReload?.defaultAmount);
  const triggerRatio = numberOrNull(business?.paymentRules?.autoReload?.triggerRatio);
  if (!range || defaultAmount === null || triggerRatio === null) {
    return null;
  }
  return { ...range, defaultAmount, triggerRatio };
};

export const getBusinessAutoReloadAmount = (business) => {
  const rawAmount = business?.reloadAmount;
  const normalized = typeof rawAmount === 'string'
    ? rawAmount.replace(/[$,]/g, '')
    : rawAmount;
  const amount = numberOrNull(normalized);
  return amount !== null && amount > 0 ? amount : null;
};

export const getMinimumLaunchBalance = (business) => (
  numberOrNull(business?.paymentRules?.launch?.minimumBalance)
);

export const hasConfiguredScale = (value, maximumScale) => {
  const [, fraction = ''] = String(value).split('.');
  return fraction.length <= maximumScale;
};

export const amountInputStep = (maximumScale) => (
  maximumScale > 0 ? 10 ** -maximumScale : 1
);

export const validateConfiguredAmount = (value, rules, subject = 'a funding amount') => {
  if (value === '') {
    return { amount: null, error: '' };
  }
  if (!rules) {
    return {
      amount: null,
      error: 'Payment limits are unavailable. Refresh the page and try again.',
    };
  }
  if (!/^[+-]?\d+(?:\.\d+)?$/.test(value)) {
    return { amount: null, error: 'Enter a valid dollar amount.' };
  }
  if (!hasConfiguredScale(value, rules.maximumScale)) {
    return {
      amount: null,
      error: rules.maximumScale === 0
        ? `Enter ${subject} as a whole-dollar amount.`
        : `Enter ${subject} with up to ${rules.maximumScale} decimal places.`,
    };
  }
  const amount = Number(value);
  if (amount < rules.minimumAmount || amount > rules.maximumAmount) {
    return {
      amount: null,
      error: `Enter ${subject} from $${rules.minimumAmount} to $${rules.maximumAmount}.`,
    };
  }
  return { amount, error: '' };
};
